import { render, staticRenderFns } from "./ReporteStockUpdate.vue?vue&type=template&id=2c7670f9&scoped=true"
import script from "./ReporteStockUpdate.vue?vue&type=script&lang=js"
export * from "./ReporteStockUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7670f9",
  null
  
)

export default component.exports